import React, { useContext, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useSocketEvent } from '../context/SocketContext';
import { NotificationContext } from '../context/NotificationContext';
import { SocketEvent, ViewedProfileUpdate } from './unifiedSocket';
import { addRecentViewer } from './recentViewers';

const VisitorSocketManager: React.FC = () => {
  const navigate = useNavigate();
  const { addNotification } = useContext(NotificationContext);

  const handleViewedProfile = useCallback((event: SocketEvent<ViewedProfileUpdate>) => {
    const { viewerId, message, thumb, profileUrl } = event.data;

    // Track this viewer so ChatSocketManager can delay a matching message toast
    addRecentViewer(viewerId);

    addNotification({
      message,
      level: 'info',
      timeout: 5000,
      dismissible: true,
      avatarUrl: thumb,
      onClick: () => navigate(profileUrl),
    });
  }, [addNotification, navigate]);

  useSocketEvent<ViewedProfileUpdate>('event/viewed-profile', handleViewedProfile);

  return null;
};

export default VisitorSocketManager;
